import BillingHTTP from 'utils/billing-http';

class InstitutionPanelService {
  loadInstitution(encryptedInstitutionId) {
    return BillingHTTP.getContent(`/institution-panel/institutions/${encryptedInstitutionId}`);
  }

  loadStudentBillings(encryptedInstitutionId, studentCpf, studentCpfHash) {
    return BillingHTTP.getContent(
      '/institution-panel/student-billings',
      { encrypted_institution_id: encryptedInstitutionId, cpf: studentCpf, cpf_hash: studentCpfHash },
    );
  }

  downloadBoleto(encryptedInstitutionId, billPaymentId) {
    return BillingHTTP.getContent(
      `/institution-panel/${encryptedInstitutionId}/boleto/download/${billPaymentId}`,
      {},
      {
        headers: { Accept: 'application/pdf', 'Content-type': 'application/pdf' },
        responseType: 'blob',
      },
    );
  }

  createBoletoBillPayment(encryptedInstitutionId, billId) {
    return BillingHTTP.postContent(
      '/institution-panel/boleto',
      { encrypted_institution_id: encryptedInstitutionId, bill_id: billId },
    );
  }

  checkBoletoBillPaymentStatus(encryptedInstitutionId, billPaymentId) {
    return BillingHTTP.getContent(`/institution-panel/${encryptedInstitutionId}/boleto/status/${billPaymentId}`);
  }
}

export default new InstitutionPanelService();
